// extracted by mini-css-extract-plugin
export var socialLink = "social-links-module--social-link--aa277";